// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import i18n from '@/locale/index';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import 'lib-flexible/flexible.js';

Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);

Vue.config.productionTip = false

router.afterEach((to,from,next) => {
  let mainDom = document.querySelector('.el-main')
  if(mainDom){
    mainDom.scrollTop = 0
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js